"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoSchool = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NoSchool = require("./NoSchool.styles");
var _NoSchool2 = require("./NoSchool.labels");
var _hooks = require("../../hooks");
var _A = require("../../UI/A");
var _Button = require("../../UI/Button");
var _Modal = require("../../Layout/Modal");
var _urls = require("../../utilities/urls");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const NoSchool = props => {
  const {
    layout = 'popup',
    techSupportUrl = _urls.supportUrl,
    logoutUrl = document.location.origin,
    onClose
  } = props;
  const {
    isSessionDataReady,
    firstName = ''
  } = (0, _hooks.useSessionData)();
  const styles = (0, _NoSchool.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _NoSchool2.labels
  });
  const [isPopupOpen, setIsPopupOpen] = (0, _react.useState)(true);
  const handleClose = event => {
    setIsPopupOpen(false);
    window.cet.accessmanagement.logout(logoutUrl);
    if (onClose) {
      onClose(event);
    }
  };
  if (!isSessionDataReady) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-NoSchool'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
      layout: layout,
      isOpen: isPopupOpen,
      onClose: handleClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        title: getLabel('hello_user_name').replace('{X}', firstName),
        subTitle: getLabel('good_to_have_you')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
        children: [getLabel('message'), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: getLabel('now_what')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('go_to'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
            to: techSupportUrl,
            target: "_blank",
            children: getLabel('tech_support')
          }), ".", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('use_as_guest')]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            color: "primary",
            onClick: handleClose,
            id: "ccNoSchoolButton",
            children: getLabel('confirm')
          })
        })
      })]
    })
  });
};
exports.NoSchool = NoSchool;